jQuery(document).ready(function ($) {
  document.querySelector('a[data-bs-toggle]').setAttribute("target", "_blank")
  document.querySelector('a[data-bs-toggle]').removeAttribute("data-id")
  document.querySelector('a[data-bs-toggle]').removeAttribute("data-bs-target")
  document.querySelector('a[data-bs-toggle]').removeAttribute("data-bs-toggle")
  
  var stickyElement = $(".sticky-element");
  // Element to be made sticky
  var lastScrollTop = 0;
  if(stickyElement.length > 0){
    var elementOffset = stickyElement.offset().top;
  }
  // Initial position of the element

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();

    let headerHt = document.querySelector('#SiteHeader').clientHeight + 10;
    // document.querySelector('.layout-right').style.top = headerHt+'px';
    // if(stickyElement.length > 0){
    //   if (scrollTop > lastScrollTop) {
    //     // Scrolling Down
    //     if (scrollTop >= elementOffset) {
    //       // stickyElement.addClass("is-sticky");
    //       stickyElement.css(
    //         "top",
    //         document.querySelector("#SiteHeader").clientHeight + "px"
    //       );
    //     }
    //   } else {
    //     // Scrolling Up
    //     if (scrollTop < elementOffset) {
    //       stickyElement.removeClass("is-sticky");
    //       stickyElement.css("top", "unset");
    //     }
    //   }
    // }
    
    lastScrollTop = scrollTop;
    var headerHeight = $("header").height();
    // var indexmnuHeight = $(".indextabs").height();
    var indexmnuHeight = 0;

    // Highlight active tab while scrolling
    // $(
    //   "div.common-section, div.h2_faq, div.cmn-section, div.share-exp-section"
    // ).each(function () {
    //   var sectionTop =
    //     $(this).offset().top - headerHeight - indexmnuHeight;
    //   // Adjust for header height
    //   var sectionId = $(this).attr("id");

    //   if (scrollTop >= sectionTop) {
    //     $(".cdv5-indextabs ul li a").removeClass("active");
    //     var activeLink = $(
    //       '.cdv5-indextabs ul li a[href="#' + sectionId + '"]'
    //     );
    //     activeLink.addClass("active");
    //   }
    // });
  });

  // Smooth scroll to section when clicking on navigation links
  $(".cdv5-indextabs ul li a").on("click", function (e) {
    e.preventDefault();
    var targetId = $(this).attr("href");
    // Get section ID
    var headerHeight = $("header").outerHeight() || 0;
    // var indexmnuHeight = $(".indextabs").outerHeight() || 0;
    var indexmnuHeight = 0;

    var targetOffset =
      $(targetId).offset().top - headerHeight - indexmnuHeight;
    // Adjust for header + menu height

    $("html, body").animate(
      {
        scrollTop: targetOffset,
      },
      800
    );
    // Smooth scroll
  });

  $("#tabModules li:contains('Preview') a").each(function () {
    $(this).text("");
    // Remove the text inside the <a> tag
  });
  $("div.video-acrdn ol").addClass("faq-list-title");
  if ($("#tabModules").hasClass("half-width")) {
    var firstHref = $("#tabModules .accordion-item a:first").attr("href");
    $("#tabModules .accordion-item a:first").addClass("activelink");
    if (firstHref) {
      var embedUrl = getYoutubeVideoId(firstHref);
    }
    if (firstHref && embedUrl) {
      $("#youtube-video").attr("src", embedUrl);
      $(".full-width").hide();
      $(".full-width").removeAttr("id");
    } else {
      $(".half-width").hide();
      $(".half-width").removeAttr("id");
      AOS.refresh();
    }

    $("#tabModules .accordion-item a").on("click", function (e) {
      $("#tabModules .accordion-item a").removeClass("activelink");
      e.preventDefault();
      var videoUrl = $(this).attr("href");
      $(this).addClass("activelink");
      var embedUrl = getYoutubeVideoId(videoUrl);

      $("#youtube-video").attr("src", embedUrl);
      // Scroll to the video section
      document.getElementById("tabModules").scrollIntoView({
        behavior: "smooth",
      });
    });

    function getYoutubeVideoId(url) {
      if (url.includes("v=")) {
        var videoId = url.split("v=")[1];
        var embedUrl = "https://www.youtube.com/embed/" + videoId;
      } else {
        console.log("URL format not recognized:", url);
      }
      console.log(embedUrl);
      return embedUrl;
    }
    // JavaScript to highlight li elements containing the preview link
    const listItems = document.querySelectorAll(".faq-list-title li");

    listItems.forEach((item) => {
      const previewLink = item.querySelector("a");
      if (previewLink) {
        previewLink.classList.add("float-end");
        item.classList.add("primary_color");
        // Add highlight class
        $(previewLink)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .find("button")
          .addClass("primary_color");
        var accbtncontent = $(previewLink).parent().parent().parent().parent();
        var accbtn = $(previewLink)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .find("button");
        if ($(accbtn).attr("aria-expanded") === "false") {
          $(accbtn).attr("aria-expanded", "true");
        }
        if ($(accbtn).hasClass("collapsed")) {
          $(accbtn).removeClass("collapsed");
          $(accbtncontent).addClass("show");
        }
      }
    });
  }

  function addHrefToLiForMobile() {
    if ($(window).width() <= 768) {
      $(".faq-list-title li").each(function () {
        var listItem = $(this);
        var anchor = listItem.find("a");
        listItem.find("a").hide();
        if (anchor.length) {
          var youtubeUrl = anchor.attr("href");
          // Get the YouTube link from the anchor
          listItem.attr("data-bs-toggle", "modal");
          listItem.attr("data-bs-target", "#exampleModal");

          listItem.click(function () {
            // Parse the YouTube video ID from the URL
            var videoId = youtubeUrl.split("v=")[1];
            var ampersandPosition = videoId.indexOf("&");
            if (ampersandPosition != -1) {
              videoId = videoId.substring(0, ampersandPosition);
            }

            // Inject the YouTube iframe into the modal
            $("#video-container").html(
              '<iframe src="https://www.youtube.com/embed/' +
                videoId +
                '" frameborder="0" loading="lazy" allowfullscreen></iframe>'
            );
          });
        }
      });
    }
  }

  // Run the function when the page loads
  addHrefToLiForMobile();

  // Run the function again when the window is resized (to handle changes in screen width)
  $(window).resize(function () {
    addHrefToLiForMobile();
  });
  // Clear the modal content and stop video playback when it's closed
  $("#exampleModal").on("hidden.bs.modal", function () {
    $("#video-container").html("");
    // Clear iframe content to stop the video
  });
  
    $(".readmore-btn").click(function() {
       $(this).prev(".readmore-text").parent().toggleClass("expanded");
       $(this).text($(this).text() === "Read More" ? "Read Less" : "Read More");
    });
  
    $(".readmore1-btn").click(function () {
      $(this).prev(".skillspills").parent().toggleClass("expanded");
      $(this).text($(this).text() === "+ More" ? "- Less" : "+ More");
    });
});

function formatTime(seconds) {
  if (isNaN(seconds) || seconds < 0) return "0:00";
  var min = Math.floor(seconds / 60);
  var sec = Math.floor(seconds % 60);
  return min + ":" + (sec < 10 ? "0" : "") + sec;
}

document.querySelectorAll(".custom-audio-player").forEach(function (player) {
  var audioElement = player.querySelector(".audio-element");
  var playBtn = player.querySelector(".play-btn");
  var playIcon = playBtn.querySelector(".play-icon");
  var pauseIcon = playBtn.querySelector(".pause-icon");
  var durationSpan = player.querySelector(".duration");
  var progressBar = player.querySelector(".progress-bar");
  var progressCircle = player.querySelector(".progress-ring-circle");
  var progressContainer = player.querySelector(".progress-container");
  var circleLength = 82;
  audioElement.addEventListener("loadedmetadata", function () {
    durationSpan.textContent =
      formatTime(audioElement.currentTime) +
      " / " +
      formatTime(audioElement.duration);
  });
  playBtn.addEventListener("click", function () {
    if (audioElement.paused) {
      document.querySelectorAll(".audio-element").forEach((el) => {
        if (el !== audioElement) {
          el.pause();
        }
      });
      document
        .querySelectorAll(".play-icon")
        .forEach((el) => (el.style.display = "inline"));
      document
        .querySelectorAll(".pause-icon")
        .forEach((el) => (el.style.display = "none"));
      audioElement.play();
      playIcon.style.display = "none";
      pauseIcon.style.display = "inline";
      $(".stop-pause").css("display", "none");
      $(".play-on").css("display", "inline");
    } else {
      audioElement.pause();
      playIcon.style.display = "inline";
      pauseIcon.style.display = "none";
      $(".stop-pause").css("display", "inline");
      $(".play-on").css("display", "none");
    }
  });
  audioElement.addEventListener("timeupdate", function () {
    var remainingTime = audioElement.duration - audioElement.currentTime;
    durationSpan.textContent = formatTime(remainingTime);
    var progress = (audioElement.currentTime / audioElement.duration) * 100;
    progressBar.style.width = progress + "%";
    var dashOffset = circleLength - (progress / 100) * circleLength;
    progressCircle.style.strokeDashoffset = dashOffset;
  });
  audioElement.addEventListener("ended", function () {
    playIcon.style.display = "inline";
    pauseIcon.style.display = "none";
    $(".stop-pause").css("display", "inline");
    $(".play-on").css("display", "none");
    progressBar.style.width = "0%";
    progressCircle.style.strokeDashoffset = circleLength;
    durationSpan.textContent = formatTime(audioElement.duration);
    audioElement.currentTime = 0;
  });
  function seekAudio(event) {
    var rect = progressContainer.getBoundingClientRect();
    var offsetX = event.clientX - rect.left;
    var newTime = (offsetX / rect.width) * audioElement.duration;
    audioElement.currentTime = newTime;
  }
  progressContainer.addEventListener("click", seekAudio);
  let isDragging = false;
  progressContainer.addEventListener("mousedown", function (event) {
    isDragging = true;
    seekAudio(event);
  });
  document.addEventListener("mousemove", function (event) {
    if (isDragging) {
      seekAudio(event);
    }
  });
  document.addEventListener("mouseup", function () {
    isDragging = false;
  });
});

// $(".opp-slider, .More_Certificate, .h2_popular_certifications .testimonials").addClass("owl-carousel owl-theme");

document.querySelector('.layout-right .boxtitle').innerText = document.querySelector('.opt_certificate_code').innerText.trim()

var bothEnable = false
const addBtn = document.querySelector('.custom-add');
const contactBtn = document.querySelector('.custom-contact-us');
const tableSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_468_8189" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"></rect>
                              </mask>
                              <g mask="url(#mask0_468_8189)">
                              <path d="M5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V3.15377C6.69225 2.9346 6.76567 2.7516 6.9125 2.60477C7.05933 2.4581 7.24233 2.38477 7.4615 2.38477C7.68083 2.38477 7.86383 2.4581 8.0105 2.60477C8.15733 2.7516 8.23075 2.9346 8.23075 3.15377V4.50002H15.8077V3.13477C15.8077 2.92193 15.8795 2.74368 16.023 2.60002C16.1667 2.45652 16.3449 2.38477 16.5577 2.38477C16.7706 2.38477 16.9487 2.45652 17.0922 2.60002C17.2359 2.74368 17.3077 2.92193 17.3077 3.13477V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20ZM5 8.80777H19V6.30777C19 6.23077 18.9679 6.16026 18.9038 6.09626C18.8398 6.0321 18.7692 6.00002 18.6923 6.00002H5.30775C5.23075 6.00002 5.16025 6.0321 5.09625 6.09626C5.03208 6.16026 5 6.23077 5 6.30777V8.80777ZM12 14.077C11.7552 14.077 11.5465 13.9908 11.374 13.8183C11.2017 13.6459 11.1155 13.4373 11.1155 13.1923C11.1155 12.9474 11.2017 12.7388 11.374 12.5663C11.5465 12.3939 11.7552 12.3078 12 12.3078C12.2448 12.3078 12.4535 12.3939 12.626 12.5663C12.7983 12.7388 12.8845 12.9474 12.8845 13.1923C12.8845 13.4373 12.7983 13.6459 12.626 13.8183C12.4535 13.9908 12.2448 14.077 12 14.077ZM8 14.077C7.75517 14.077 7.5465 13.9908 7.374 13.8183C7.20167 13.6459 7.1155 13.4373 7.1155 13.1923C7.1155 12.9474 7.20167 12.7388 7.374 12.5663C7.5465 12.3939 7.75517 12.3078 8 12.3078C8.24483 12.3078 8.4535 12.3939 8.626 12.5663C8.79833 12.7388 8.8845 12.9474 8.8845 13.1923C8.8845 13.4373 8.79833 13.6459 8.626 13.8183C8.4535 13.9908 8.24483 14.077 8 14.077ZM16 14.077C15.7552 14.077 15.5465 13.9908 15.374 13.8183C15.2017 13.6459 15.1155 13.4373 15.1155 13.1923C15.1155 12.9474 15.2017 12.7388 15.374 12.5663C15.5465 12.3939 15.7552 12.3078 16 12.3078C16.2448 12.3078 16.4535 12.3939 16.626 12.5663C16.7983 12.7388 16.8845 12.9474 16.8845 13.1923C16.8845 13.4373 16.7983 13.6459 16.626 13.8183C16.4535 13.9908 16.2448 14.077 16 14.077ZM12 18C11.7552 18 11.5465 17.9138 11.374 17.7413C11.2017 17.5689 11.1155 17.3603 11.1155 17.1155C11.1155 16.8705 11.2017 16.6618 11.374 16.4895C11.5465 16.317 11.7552 16.2308 12 16.2308C12.2448 16.2308 12.4535 16.317 12.626 16.4895C12.7983 16.6618 12.8845 16.8705 12.8845 17.1155C12.8845 17.3603 12.7983 17.5689 12.626 17.7413C12.4535 17.9138 12.2448 18 12 18ZM8 18C7.75517 18 7.5465 17.9138 7.374 17.7413C7.20167 17.5689 7.1155 17.3603 7.1155 17.1155C7.1155 16.8705 7.20167 16.6618 7.374 16.4895C7.5465 16.317 7.75517 16.2308 8 16.2308C8.24483 16.2308 8.4535 16.317 8.626 16.4895C8.79833 16.6618 8.8845 16.8705 8.8845 17.1155C8.8845 17.3603 8.79833 17.5689 8.626 17.7413C8.4535 17.9138 8.24483 18 8 18ZM16 18C15.7552 18 15.5465 17.9138 15.374 17.7413C15.2017 17.5689 15.1155 17.3603 15.1155 17.1155C15.1155 16.8705 15.2017 16.6618 15.374 16.4895C15.5465 16.317 15.7552 16.2308 16 16.2308C16.2448 16.2308 16.4535 16.317 16.626 16.4895C16.7983 16.6618 16.8845 16.8705 16.8845 17.1155C16.8845 17.3603 16.7983 17.5689 16.626 17.7413C16.4535 17.9138 16.2448 18 16 18Z" fill="#0A54B4"></path>
                              </g>
                            </svg>`
let isCourseDetails = sessionStorage.getItem("courseDetails") ? JSON.parse(sessionStorage.getItem("courseDetails")) : "";
const customBundleBtn = document.querySelector('#custom-add-to-cart-div');
  
function createLink(courseDetails){
  const linkElement = document.createElement('div')
  linkElement.className = 'detail-wrap'
  linkElement.innerHTML = `
                            ${tableSvg}
                            <a href="javascript: void(0);" class="openPopup" data-days="${courseDetails[0]['Duration (Days)']}" onclick="showModal(this, event)" style="color: #0A54B4; text-decoration: underline;">${courseDetails[0]['Duration (Days)']} Days | Live Online Classes</a>
                          `;
   document.querySelector('.schedule-links .couse-details').appendChild(linkElement)
}

async function fetchData(){
  window.courseDetails = undefined;
  
  
  // const response = await fetch('https://script.google.com/macros/s/AKfycbwPeP5Scrz_xz1V1r197-yD5L4Rl1DjIC_rlagJ2bFqlv0nEh2zeFsgr5JXP-lagLIk/exec?sku=' + product_sku+'&sheet=AI Certs Schedule');
  try{
  // const response = await fetch('https://script.google.com/macros/s/AKfycbxeL08hEf-wKSCLERWX5U7jYZKRk4xMosRHirPjVrLYjCCF6_9PU21vkWx1qNoZbXhoQg/exec?sku=' + product_sku);

  // const response = await fetch('https://script.google.com/macros/s/AKfycbyhQrEGo-oNhot_NDqdfWElp4ZhIEi77V-jwgSDYwbs_7f37C4iDFMmUFKuBxHCA-Hc/exec?sku=' + product_sku);
  // commented by mlveda on 6/4/26 const response = await fetch('https://script.google.com/macros/s/AKfycbyxQasH7GcBowQquzm9m0Q5laOcy3rNRU1iEnTFfDe7LkSfz-TjVJsjxM0h21gDTdUROQ/exec/exec?sku=' + product_sku);
  const response = await fetch('https://script.google.com/macros/s/AKfycby1t33lX2rVI9Mrv0Jn9WdeeAhpS2qZ0QSNIJ7eVdXKaZQW3quZCBavDoW4Zam0Tr3ovw/exec/exec?sku=' + product_sku);
  const data = await response.json();
  
  console.log(data)
  if(data.length > 0){
    window.courseDetails = data;
    courseDetails.sort((a, b) => new Date(a['Event Start']) - new Date(b['Event Start']))
    let obj = {};
    obj[product_sku] = courseDetails;
    contactBtn.style.display = 'none';
    sessionStorage.setItem("courseDetails", JSON.stringify(obj))
    
    document.querySelector('.schedule-sec').style.display = 'block';
   
    // document.querySelector('.schedule-links').style.display = 'block';
    // setTimeout(()=>{
    //   document.querySelector('[aria-controls="FAQ-content-4"]').click()
    // },100)
  }else{
    document.querySelector('.schedule-links').style.display = 'none';
    document.querySelector('.schedule-sec').style.display = 'none';
  }

  if(window.courseDetails){
      let uniqueDays = [...new Set(courseDetails.map(item => item['Duration (Days)']))];
      console.log(uniqueDays, 'uniqueDays')
      uniqueDays.forEach((day, index) => {
        let filteredArray = courseDetails.filter(item => item['Duration (Days)'] === day);
        if (filteredArray.length > 0) {
          createLink(filteredArray);
        }
      });
    // let variantName = ''
    //   if(uniqueDays.includes('1')){
    //     // document.querySelector('.variantData-1').style.display = 'block'
    //     // document.querySelector('.variantData-2').style.display = 'none'
    //     variantName = '1day'
    //   }else if(uniqueDays.includes('5')){
    //     variantName = '5days'
    //     // document.querySelector('.variantData-1').style.display = 'none'
    //     // document.querySelector('.variantData-2').style.display = 'block'
    //     // document.querySelector('select[name="id"]').value = document.querySelector('.variant-2').value
    //   }
      let variantName = uniqueDays.includes('1') ? '1day' : '5days';
      document.querySelectorAll('.online-section').forEach(item => item.style.display = 'none')
      document.querySelector('.online-section.varData-'+variantName).style.display = 'block';
      if(document.querySelector('.online-section.self-paced')){
        document.querySelector('.online-section.self-paced').style.display = 'block';
      }
      document.querySelector('select[name="id"]').value = document.querySelector(`.online-section.varData-${variantName} input`).value;
      
      // $('.certification-title').after(`<h3 style="margin-bottom: 10px;">Course Duration - 
      // ${uniqueDays[0]} ${uniqueDays[0] > 1 ? 'days' : 'day'}
      // </h3>`);
    // if(document.querySelector('.online-section')){
      
    // }
      let selfLi = selfVariantTitle ? '<li>Self-Paced: '+selfVariantTitle+'</li>' : '';
      $('.certification-title').after(`<div>
      <h3 style="margin-bottom: 10px;">Course Duration</h3>
      <ul>
        <li>Virtual Instructor Led Online: ${uniqueDays[0]} ${uniqueDays[0] > 1 ? 'days' : 'day'}</li>
        ${selfLi}
      </ul>
      </div>`);

    
      if(document.querySelectorAll('.cdv6-schedulecard ul.ms-3').length > 0){
        // if(document.querySelectorAll('.cdv6-schedulecard ul.ms-3').length > 1){
        //     const ul = document.querySelectorAll('.cdv6-schedulecard ul.ms-3')[0];
        //     const newLi = document.createElement('li');
        //     newLi.innerHTML = `Price - ${document.querySelector(`.online-section.varData-${variantName} .prod-price`).innerHTML}`;
        //     ul.children[0].after(newLi, ul.firstChild);
    
        //     const selfpacedUl2 = document.querySelectorAll('.cdv6-schedulecard ul.ms-3')[1];
        //     if(selfVariantTitle != ''){
        //       const selfPriceLi = document.createElement('li');
        //       selfPriceLi.innerHTML = `Price - ${document.querySelector(`.online-section.self-paced .prod-price`).innerHTML}`;
        //       selfpacedUl2.children[0].after(selfPriceLi, selfpacedUl2.firstChild);
        //     }
        // }else{
        //   const selfpacedUl1 = document.querySelectorAll('.cdv6-schedulecard ul.ms-3')[0];
        //   if(selfVariantTitle != ''){
        //     const selfPriceLi2 = document.createElement('li');
        //     selfPriceLi2.innerHTML = `Price - ${document.querySelector(`.online-section.self-paced .prod-price`).innerHTML}`;
        //     selfpacedUl.children[0].after(selfPriceLi2, selfpacedUl.firstChild);
        //   }
        // }
        const ul = document.querySelectorAll('.cdv6-schedulecard ul.ms-3')[0];
        const newLi = document.createElement('li');
        newLi.innerHTML = `Price - ${document.querySelector(`.online-section.varData-${variantName} .prod-price`).innerHTML}`;
        ul.children[0].after(newLi, ul.firstChild);

        if(document.querySelectorAll('.cdv6-schedulecard ul.ms-3').length > 1){
          const selfpacedUl2 = document.querySelectorAll('.cdv6-schedulecard ul.ms-3')[1];
          if(selfVariantTitle != '' && selfpacedUl2.length){
            const selfPriceLi = document.createElement('li');
            selfPriceLi.innerHTML = `Price - ${document.querySelector(`.online-section.self-paced .prod-price`).innerHTML}`;
            selfpacedUl2.children[0].after(selfPriceLi, selfpacedUl2.firstChild);
          }
        }
      }
      showModal(document.querySelectorAll('a.openPopup')[0])
    
    }else{
      
    }
  
    document.querySelector('.layout-right').style = 'visibility: visible';
  
    if(window.courseDetails == undefined){
       if(contactBtn){contactBtn.style.display = 'inline-block'}
       if(addBtn){addBtn.style.display = 'none';}
    }
    else{
      if(contactBtn){contactBtn.style.display = 'none'}
      if(addBtn){
        addBtn.style.display = 'inline-block';
        addBtn.type = "button";
        addBtn.classList.add("enrollscrollbtn");
        addBtn.querySelector("span").innerText = 'Enroll Now';
        addBtn.onclick = () => {
          document.querySelector('.schedule-sec').scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }
  catch(error){
    if(error){
      console.log(error)
      document.querySelector('.schedule-sec').style.display = 'none'
      document.querySelector('.layout-right').style.display = 'none'
    }
  }
    // document.querySelector('.form-block').style = 'opacity: 1';
  }

fetchData();

var sessionData = JSON.parse(localStorage.getItem('scheduleData')) || {};
function showModal(currentItem, event) {
          const schedule = currentItem.innerText;
          const days = currentItem.getAttribute("data-days");
          const currentPopup = document.querySelector(`.table-wrap`)
          const storedData = JSON.parse(localStorage.getItem('scheduleData'));
        
          let hasBothDate = false;
          currentPopup.querySelector('table .course-entries').innerHTML = '';
          courseDetails.filter(item => item['Duration (Days)'] == days).forEach(rowDetail => {
            
            // if(rowDetail.Status.trim() == "Cancelled") return;
          
          if(rowDetail.Status.toLowerCase().trim() == "guaranteed" || rowDetail.Status.toLowerCase().trim() == "open" || rowDetail.Status.toLowerCase().trim() == "cancelled-soldout"){
              let row = document.createElement('tr')
              row.className = 'day active'
              if(rowDetail['Event End']){
                hasBothDate = true
              }
              
              let trueIcon = '';
              if(rowDetail.Status.toLowerCase().trim() == "guaranteed" || rowDetail.Status.toLowerCase().trim() == 'cancelled-soldout'){
                trueIcon = `<svg fill="#24a148" width="20px" height="20px" viewBox="0 0 200 200" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" stroke="#24a148" stroke-width="0.002"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.4"></g><g id="SVGRepo_iconCarrier"><title></title><path d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165Zm25-91.5-29,35L76,94c-4.5-3.5-10.5-2.5-14,2s-2.5,10.5,2,14c6,4.5,12.5,9,18.5,13.5,4.5,3,8.5,7.5,14,8,1.5,0,3.5,0,5-1l3-3,22.5-27c4-5,8-9.5,12-14.5,3-4,4-9,.5-13L138,71.5c-3.5-2.5-9.5-2-13,2Z"></path></g></svg>`
              }
              let btnHtml = rowDetail.Status.toLowerCase().trim() == "cancelled-soldout" ? `<button class="btn enrollbtn btnGrayOut" onclick="window.location.href='${(rowDetail['Contact Link'] != "") ? rowDetail['Contact Link'] : '/pages/contact-us-new'}'">Sold Out</button>`: `<button class="btn enrollbtn" onclick="addCourse(this)">Enroll Now</button>`;

              row.innerHTML = `
                <td>${trueIcon}</td>
                <td class="start-date"><div class="guaranteed">${rowDetail['Event Start']}${hasBothDate ? " - "+rowDetail['Event End'] :''}</div></td>
                <td class="start-time">${rowDetail['Event Start Time']} - ${rowDetail['Event End Time']} ${rowDetail['Metro']}</td>
                <td class="enroll-btn">${btnHtml}<input type="hidden" name="_event_id" class="event_id" value="${rowDetail['Event SKU / PO#']}"></td>
              `
              currentPopup.querySelector('table .course-entries').appendChild(row)
            }
          })
        
         currentPopup.querySelector('table th.start-end-date').innerText = hasBothDate ? "Start Date - End Date" : "Start Date"
        if(event){
          event.preventDefault(); 
          event.stopPropagation(); 
          document.querySelector('.schedule-sec').scrollIntoView({ behavior: 'smooth' });
        }
    }
function toggleActive(item){
      document.querySelectorAll('.courseTiming span').forEach(removeItem=>{removeItem.classList.remove("active")})
      item.classList.add('active')
      document.querySelectorAll('.schedule-table tbody tr').forEach(row=>{row.classList.remove("active")})
      document.querySelectorAll("tbody tr."+item.getAttribute("data-time")).forEach(row => { row.classList.add("active") })
}


function addCourse(current){
  console.log(current)
  const proForm = document.querySelector('.product-single__form')
  const currentRow = current.closest('tr')
  let eventId = currentRow.querySelector('input.event_id');
  
  const inputsData = [
          { name: 'properties[_event_id]', value: eventId.value },
          { name: 'properties[Date]', value: currentRow.querySelector('.start-date').innerText.trim() },
          { name: 'properties[Time]', value: currentRow.querySelector('.start-time').innerText.trim() },
          { name: 'properties[Learning Type]', value: "Virtual Instructor-Led Online Training" }
        ];
        
  // Loop through the array and append each input
  inputsData.forEach(data => {
    const hiddenInput = document.createElement('input'); // Create input element
    hiddenInput.type = 'hidden';
    hiddenInput.name = data.name; // Set name
    hiddenInput.value = data.value; // Set value
    proForm.appendChild(hiddenInput); // Append to form
  });
  proForm.submit();
  // proForm.dispatchEvent(new Event("submit"));
}

const timevalue = document.querySelector('.selected-course-details .timevalue-value')
const dateValue = document.querySelector('.selected-course-details .date-value')

function scrollToSection(current){
  console.log(current)
  document.querySelector('.schedule-sec').scrollIntoView({ behavior: 'smooth' })
}


$('.cmn-sliderdots .common-cnt .owl-carousel').owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    items: 1,
    responsiveClass: true,
  smartSpeed: 800,
  slideTransition: 'linear',
    responsive: {
        0: {
            items: 1,
        },
        768: {
            items: 2,
        },
        1024: {
            items: 3,
        }
    }
})

$('.CertificateSuggestions .owl-carousel').owlCarousel({
    loop: false,
    margin: 50,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    items: 1,
    responsiveClass: true,
    smartSpeed: 800,
    slideTransition: 'linear',
    responsive: {
        0: {
            items: 2,
            nav: true,
            margin: 20,
        },
        600: {
            items: 3,
            nav: true,
            margin: 20,
        },
        991: {
            items: 4,
            nav: true,
            margin: 30,
        },
        1200: {
            items: 6,
        }
    }
})

var owl = $(".h2_popular_certifications .owl-carousel");
owl.owlCarousel({
    items: 2,
    margin: 20,
    loop: false,
    nav: true,
    smartSpeed: 800,
    slideTransition: 'linear',
    responsive: {
        0: {
            items: 1,
            margin: 10,
        },
        768: {
            items: 2,
            margin: 20,
        },
        1024: {
            items: 3,
            margin: 20,
        },
        1200: {
            items: 4,
            margin: 20,
        },
        1400: {
            items: 4,
            margin: 20,
        },
        1600: {
            items: 5,
            margin: 20,
        }
    }
})

$('a:contains("Enroll Now"), a:contains("Buy Instructor-Led Course"), a:contains("Purchase Exam")').on('click', (e)=>{
  e.preventDefault();
  // document.querySelector('.schedule-sec').scrollIntoView({ behavior: 'smooth' })
  manualScroll();
})
if($('a:contains("Purchase Self-Paced Course")')){
  $('a:contains("Purchase Self-Paced Course")').addClass("purchaseForm")
}
document.querySelectorAll('#tabLearning a').forEach(btn => btn.addEventListener('click', (e) =>{
    e.preventDefault();
    if(e.currentTarget.classList.contains("purchaseForm") && document.querySelector("#selfPaceForm")){
      document.querySelector("#selfPaceForm").submit();
      return
    }
    manualScroll();
    // document.querySelector('.schedule-sec').scrollIntoView({ behavior: 'smooth' })
}))
function manualScroll() {
  const target = document.querySelector('.schedule-sec');
  const offset = 100; // Adjust based on your slider height
  
  const targetPosition = target.getBoundingClientRect().top + window.scrollY - document.querySelector('header').clientHeight + 30;
  
  window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
  });
  
}



document.querySelectorAll(".CertificateSuggestions a.js-no-transition").forEach((link)=>{
  link.addEventListener("click",(e)=>{
    e.preventDefault();
    const link_url=e.currentTarget.href;
    let sliced = link_url[link_url.length -1] === '/' ? link_url.slice(0,link_url.length - 1) : link_url.slice(0,link_url.length) 
    const val=sliced.slice(sliced.lastIndexOf("/"),sliced.length);
    window.open(`https://upskillacademy.mycomputercareer.edu/products${val}`, '_blank');
  })
})